<a *ngFor="let anchor of guideService.anchors" [href]="getHref(anchor.name)" [class.current]="guideService.current === anchor.name">
  <i class="material-icons">{{anchor.icon}}</i>
  <span>{{anchor.name}}</span>
</a>
